/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Warning_DetailInputs */

const vi_import_warning_detail = /** @type {(inputs: Import_Warning_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung cảnh báo`)
};

/**

* @param {Import_Warning_DetailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_warning_detail = /** @type {((inputs?: Import_Warning_DetailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Warning_DetailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_warning_detail(inputs)
});